import { createHoldingsNotVisibleQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useHoldingsNotVisibleQuery = createHoldingsNotVisibleQuery(HTTP_CONFIG.API.Optimizely.url)
